export enum FilesPermissions {
  FilesManual = 'files-manual',
  FilesShared = 'files-shared',
}